import { t } from 'i18next';
import Cookies from 'js-cookie';
import { Component, ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { Link, TrackedLink } from '../link';

const styles = {
  wrapper: 'cookie-footer--wrapper slds-p-around--small',
  copy: 'cookie-footer--copy slds-p-bottom--small',
  accept_button:
    'cookie-footer--accept_button slds-button slds-button--brand slds-text-body--small slds-p-vertical--x-small slds-p-horizontal--medium text-nowrap',
  reject_button:
    'cookie-footer--reject_button slds-button slds-button--neutral slds-text-body--small slds-p-vertical--x-small slds-p-horizontal--medium text-nowrap',
  button_group: 'cookie-footer--button_group',
  close_button: 'cookie-footer--close_button slds-text-heading--large',
  dismiss_button:
    'slds-button slds-button--neutral slds-text-heading--medium slds-p-vertical--x-small slds-p-horizontal--medium'
};

export const COOKIES_ENABLED_KEY = 'rio-cfs';

type TCookieFooterProps = {
  policyLinksVariant?: 'internal' | 'external';
  externalPolicyBaseUrl?: string;
};

type TCookieFooterState = {
  show: boolean;
};

export default class extends Component<TCookieFooterProps, TCookieFooterState> {
  public constructor(props: TCookieFooterProps, ctx: any) {
    super(props, ctx);
    this.state = {
      show: false
    };
  }

  // rio-cfs = RaiderIO Cookie Footer Status
  public componentDidMount() {
    if (document.cookie.indexOf(COOKIES_ENABLED_KEY) === -1) {
      // cookie not set, so we need to prompt them
      this.setState({
        show: true
      });
    }
  }

  public render(): ReactElement<any> | null {
    if (!this.state.show) {
      return null;
    }

    const policyLinksVariant = this.props.policyLinksVariant || 'internal';
    const policyBaseUrl = this.props.externalPolicyBaseUrl || RIO_ALL_SITES.wowretail.external_url;

    return (
      <div className={styles.wrapper}>
        <div className={styles.copy}>
          <Trans i18nKey="common:cookies-footer.description">
            {policyLinksVariant === 'external' ? (
              <TrackedLink href={`${policyBaseUrl}/cookies-policy`}>Cookies Policy</TrackedLink>
            ) : (
              <Link to="/cookies-policy">Cookies Policy</Link>
            )}
            {policyLinksVariant === 'external' ? (
              <TrackedLink href={`${policyBaseUrl}/privacy-policy`}>Privacy Policy</TrackedLink>
            ) : (
              <Link to="/privacy-policy">Privacy Policy</Link>
            )}
            {policyLinksVariant === 'external' ? (
              <TrackedLink href={`${policyBaseUrl}/terms-of-use`}>Terms of Use</TrackedLink>
            ) : (
              <Link to="/terms-of-use">Terms of Use</Link>
            )}
          </Trans>
        </div>
        <div className={styles.button_group}>
          <button type="button" className={styles.accept_button} onClick={this.acceptAlert}>
            {t('common:cookies-footer.button')}
          </button>
          <button type="button" className={styles.reject_button} onClick={this.rejectAlert}>
            {t('common:cookies-footer.reject-button')}
          </button>
        </div>
      </div>
    );
  }

  private acceptAlert = () => {
    RIO_TRACK_EVENT('event', 'cookie_footer_accepted');
    Cookies.set(COOKIES_ENABLED_KEY, 'accepted', { expires: 365 });
    this.setState({ show: false });

    // Update GA Consent Mode
    const w = window as any;
    if (typeof w.gtag === 'function') {
      w.gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted'
      });
    }

    // Load Quantcast Measure (deferred loader set up in server template)
    if (typeof w.__RIO_LOAD_QUANTCAST === 'function') {
      w.__RIO_LOAD_QUANTCAST();
    }

    // Signal to Clarity and any other consent-aware components
    window.dispatchEvent(new Event('rio:consent-accepted'));
  };

  private rejectAlert = () => {
    RIO_TRACK_EVENT('event', 'cookie_footer_rejected');
    Cookies.set(COOKIES_ENABLED_KEY, 'rejected', { expires: 365 });
    this.setState({ show: false });
  };
}
